module.exports = __webpack_public_path__ + "img/m-banner-mhqtbhqs-zh-TW.519cb912.png";